import { type MouseEvent, memo } from 'react';

import { WorkspaceAgentGuidedVariantSizeGroupToggle } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSizeGroupToggle';
import { WorkspaceAgentGuidedVariantSizeOptionRow } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSizeOptionRow';
import { WORKSPACE_AGENT_GUIDED_VARIANT_SIZE_PLATFORM_ICONS } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/workspaceAgentGuidedVariantSizeIcons';
import {
  isWorkspaceAgentSmartResizeSizeSelected,
  WORKSPACE_AGENT_SMART_RESIZE_SOCIAL_GROUPS,
  type WorkspaceAgentSmartResizeSize,
  workspaceAgentSmartResizeChannelToSize,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentSmartResize';

export type WorkspaceAgentGuidedVariantSmartResizeSocialGroupProps = {
  isExpanded: boolean;
  onSelectSize: (event: MouseEvent<HTMLButtonElement>) => void;
  onToggle: (event: MouseEvent<HTMLButtonElement>) => void;
  sizes: readonly WorkspaceAgentSmartResizeSize[];
};

export const WorkspaceAgentGuidedVariantSmartResizeSocialGroup = memo(
  ({ isExpanded, onSelectSize, onToggle, sizes }: WorkspaceAgentGuidedVariantSmartResizeSocialGroupProps) => (
    <div>
      <WorkspaceAgentGuidedVariantSizeGroupToggle
        groupId="social"
        isExpanded={isExpanded}
        label="Social sizes"
        onToggle={onToggle}
      />
      {isExpanded ? (
        <div className="flex flex-col pl-6">
          {WORKSPACE_AGENT_SMART_RESIZE_SOCIAL_GROUPS.map((group) => {
            const Icon = WORKSPACE_AGENT_GUIDED_VARIANT_SIZE_PLATFORM_ICONS[group.id];

            return (
              <fieldset aria-label={group.label} className="m-0 flex min-w-0 flex-col border-0 p-0" key={group.id}>
                <p className="-ml-3 flex items-center gap-1.5 px-1.5 pt-2 font-bold ads:text-metadata text-10 text-gray-10 uppercase tracking-wide">
                  {Icon ? (
                    // Brand marks paint their own fills, so force the same gray as the other menu icons.
                    <Icon
                      aria-hidden
                      className="size-3.5 shrink-0 ads:text-icon-default text-gray-10 [&_path]:fill-current"
                    />
                  ) : null}
                  {group.label}
                </p>
                {group.sizes.map((channel) => (
                  <WorkspaceAgentGuidedVariantSizeOptionRow
                    channel={channel}
                    isSelected={isWorkspaceAgentSmartResizeSizeSelected(
                      sizes,
                      workspaceAgentSmartResizeChannelToSize(channel),
                    )}
                    key={channel.id}
                    onClick={onSelectSize}
                  />
                ))}
              </fieldset>
            );
          })}
        </div>
      ) : null}
    </div>
  ),
);

WorkspaceAgentGuidedVariantSmartResizeSocialGroup.displayName = 'WorkspaceAgentGuidedVariantSmartResizeSocialGroup';
